import './Discografia.css';

import { useState } from "react";

const Discografia = () => {
    const albuns = [
        {
            imagem: "album-3.png",
            nome: "Brasil Papaya",
            plataformas: {
                tratore: "https://tratore.ﬀm.to/brasilpapaya",
            }
        },
        {
            imagem: "album-2.png",
            nome: "Esperanza",
            plataformas: {
                spotify: "https://open.spotify.com/intl-pt/album/5ChLWF0ovJJJamEg4P8Yyh?si=P7aUjpJBT9e8D2anLqxDaA",
                youtube: "https://youtube.com/playlist?list=OLAK5uy_kpQK0SwELneelWhwHuQmk18bc_UyXbhbw&si=sT6JlHo_dfdL5521",
                shazam: "https://www.shazam.com/es-es/artist/brasil-papaya/181997083",
                deezer: "https://deezer.page.link/j1sMB9CAnRuAiTTn7",
                amazon: "https://amazon.com/music/player/albums/B000QZTW0S?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_Zv2o6U8aTZOU4Y8WMHeddn2UY",
                apple: "https://music.apple.com/br/album/esperanza/181996911"
            }
        },
        {
            imagem: "album-1.png",
            nome: "Emancipation",
            plataformas: {
                youtube: "https://youtube.com/@brasilpapaya?si=42HJ5eO10G971D9h",
            }
        }
    ];

    const collabs = [
        {
            imagem: "album-5.png",
            nome: "Seis Cordas",
            plataformas: {
                "digital": "https://discografia.discosdobrasil.com.br/discos/seis-cordas"
            }
        },
        {
            imagem: "album-6.png",
            nome: "Classicos com Energia",
            plataformas: {
                "http://www.camerataflorianopolis.com.br": "https://www.camerataflorianopolis.com.br/discografia",
            }
        },
        {
            imagem: "album-4.png",
            nome: "Rock 'n Camerata",
            plataformas: {
                "http://www.camerataflorianopolis.com.br": "https://www.camerataflorianopolis.com.br/discografia",
            }
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedAlbum, setSelectedAlbum] = useState(null);

    const goToSlide = (index) => setCurrentIndex(index);

    const openModal = (album) => {
        setSelectedAlbum(album);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedAlbum(null);
    };

    return (
        <section className="discografia">
            <img src="QRCODE.png" alt="QR Code" className="qr-code" />

            <div className="discografia-container">
                <h2 className="discografia-title">Discografia</h2>
                <p className="discografia-description">
                    Você pode ouvir a Brasil Papaya na sua plataforma preferida.
                </p>

                {/* CAROUSEL DE ÁLBUNS */}
                <div className="carousel-discografia">
                    <div className="carousel-images-discografia">
                        {albuns.map((album, index) => (
                            <div
                                key={index}
                                className={`carousel-image-discografia ${index === currentIndex ? "active" : ""}`}
                                onClick={() => openModal(album)}
                            >
                                <img src={album.imagem} alt={album.nome} />
                            </div>
                        ))}
                    </div>
                    <div className="carousel-indicators-discografia">
                        {albuns.map((_, index) => (
                            <span
                                key={index}
                                className={`indicator-discografia ${index === currentIndex ? "active" : ""}`}
                                onClick={() => goToSlide(index)}
                            />
                        ))}
                    </div>
                </div>

                <p className="discografia-description">Participações Especiais</p>

                {/* CAROUSEL DE COLLABS */}
                <div className="carousel-discografia">
                    <div className="carousel-images-discografia">
                        {collabs.map((album, index) => (
                            <div
                                key={index}
                                className={`carousel-image-discografia ${index === currentIndex ? "active" : ""}`}
                                onClick={() => openModal(album)}
                            >
                                <img src={album.imagem} alt={album.nome} />
                            </div>
                        ))}
                    </div>
                    <div className="carousel-indicators-discografia">
                        {collabs.map((_, index) => (
                            <span
                                key={index}
                                className={`indicator-discografia ${index === currentIndex ? "active" : ""}`}
                                onClick={() => goToSlide(index)}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* MODAL */}
            {isModalOpen && selectedAlbum && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>×</button>
                        <h3>{selectedAlbum.nome}</h3>
                        <ul className="modal-platforms">
                            {Object.entries(selectedAlbum.plataformas).map(([key, url]) => (
                                <li key={key}>
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {key.charAt(0).toUpperCase() + key.slice(1)}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Discografia;
